exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wrapper>*{transition:transform .5s;transform:translateY(120%)}.wrapper.is-active>*{transform:translateY(0)}", ""]);

// exports
